export enum QDrawerAction {
  confirm = 'confirm',
  cancel = 'cancel',
  close = 'close'
}
